import Modal from './modal';
import countries from './countries';

function getFormFieldByName(fields, name) {
  const value = fields.find((el) => el.name === name);
  if (!value) {
    return { value: name, not_found: true, name };
  }
  return value;
}

export default function signUpFormControl() {
  // STEP 1.1
  $(document.body).on('click', '.customer-type--select-personal', function (event) {
    event.preventDefault();
    event.stopPropagation();
    new Modal({
      body: '<section class="card h-auto mx-auto rounded-5 complete-registration-qr"><div class="mx-auto modal-scroll"><h1 class="text-wrap text-center">Complete registration via the App!</h1><h2 class="text-wrap text-center pt-2 pb-1 mx-auto">Scan the QR to visit the App Store and download the EmbassyCard App. </h2><div class="row modal-qr w-100 mx-auto align-middle justify-content-center"><div class="col"><div class="p-1 rounded-4 qr-container"><div class="rounded-4 qr-code"><img src="/wp-content/themes/embassy-card/assets/images/svg/play_store_ec_qr.svg" alt="qr-play store" width="100%" height="100%"></div><h2 class="text-center">Download for Android</h2></div><div class="mx-auto store-badge"><a title="google play"  href="https://play.google.com/store/apps/details?id=com.embassycard.terminal.prod"><img src="/wp-content/themes/embassy-card/assets/images/qr/Google_Play_Store_badge_EN-1536x452.png" width="100%"  alt="google play"></a></div></div><div class="col"><div class="p-1 rounded-4 qr-container2"><div class="rounded-4 qr-code"><img src="/wp-content/themes/embassy-card/assets/images/svg/app_store_ec_qr.svg" alt="qr-app store" width="100%" height="100%"></div><h2 class="text-center">Download for iOS</h2></div><div class="mx-auto store-badge"><a title="app play"  href="https://apps.apple.com/mt/app/embassycard/id1522662487"><img src="/wp-content/themes/embassy-card/assets/images/qr/Download_on_the_App_Store_Badge-1536x455.png" width="100%"  alt="app play"></a></div></div></div></div></section>',
      fnContinue: () => {
        $(this).parents('form').submit();
      },
      fnBack: () => {
        window.location.href = '/';
      },
      backButtonText: 'No',
      backButtonState:'disabled',
      continueButtonState: 'disabled',
      continueButtonText: 'Yes continue'
    });
  });

  $(document.body).on('click', '.customer-type--select-merchant', function (event) {
    event.preventDefault();
    event.stopPropagation();
    new Modal({
      body: '<section class="card h-auto mx-auto rounded-5 complete-registration-qr"><div class="mx-auto modal-scroll"><h1 class="text-wrap text-center">Complete registration via the App!</h1><h2 class="text-wrap text-center pt-2 pb-1 mx-auto">Scan the QR to visit the App Store and download the EmbassyCard App. </h2><div class="row modal-qr w-100 mx-auto align-middle justify-content-center"><div class="col"><div class="p-1 rounded-4 qr-container"><div class="rounded-4 qr-code"><img src="/wp-content/themes/embassy-card/assets/images/svg/play_store_ec_qr.svg" alt="qr-play store" width="100%" height="100%"></div><h2 class="text-center">Download for Android</h2></div><div class="mx-auto store-badge"><a title="google play"  href="https://play.google.com/store/apps/details?id=com.embassycard.terminal.prod"><img src="/wp-content/themes/embassy-card/assets/images/qr/Google_Play_Store_badge_EN-1536x452.png" width="100%"  alt="google play"></a></div></div><div class="col"><div class="p-1 rounded-4 qr-container2"><div class="rounded-4 qr-code"><img src="/wp-content/themes/embassy-card/assets/images/svg/app_store_ec_qr.svg" alt="qr-app store" width="100%" height="100%"></div><h2 class="text-center">Download for iOS</h2></div><div class="mx-auto store-badge"><a title="app play"  href="https://apps.apple.com/mt/app/embassycard/id1522662487"><img src="/wp-content/themes/embassy-card/assets/images/qr/Download_on_the_App_Store_Badge-1536x455.png" width="100%"  alt="app play"></a></div></div></div></div></section>',
      fnContinue: () => {
        $(this).parents('form').submit();
      },
      fnBack: () => {
        window.location.href = '/';
      },
      backButtonText: 'No',
      backButtonState:'disabled',
      continueButtonState: 'disabled',
      continueButtonText: 'Yes continue'
    });
  });

  // STEP 2.1
  $('input[name=nfc]').on('change', function (event) {
    if($(this).val() == 1) {
      $('#nfc-selected-value').val('yes');
      $('.nfc-disclaimer--yes').removeClass('d-none').addClass('d-block');
      $('.nfc-disclaimer--no').removeClass('d-block').addClass('d-none');
    } else {
      if($(this).hasClass('merchant')) {
        event.preventDefault();
        event.stopPropagation();
        $(this).prop('checked', false);
        new Modal({
          body: '<h1 class="green mb-5">NFC Phone Requirement</h1><p class="small mb-5">To become an EmbassyCard Merchant (accept payments, top-up card, earn commission etc), you must have a NFC-enabled phone. If you don’t have one, then unfortunately you cannot continue to register for a Merchant account.</p><h2 class="small">Would you like to register for a Customer Account instead?</h2>',
          fnContinue: () => {
            $(this).parents('form').find('input[name=action]').val('switch_to_customer');
            $(this).parents('form').find('input[name=phoneNumberPost]').removeAttr('required').removeClass('validate');
            $(this).parents('form').submit();
          },
          backButtonText: 'Edit',
          continueButtonText: 'Get Customer Account'
        });

      } else {
        $('#nfc-selected-value').val('no');
        $('.nfc-disclaimer--yes').removeClass('d-block').addClass('d-none');
        $('.nfc-disclaimer--no').removeClass('d-none').addClass('d-block');
      }
    }
  });

  // let nfcModalOpen = false;
  // $(document.body).on('click', '.js-open-nfc-modal', function (event) {
  //   if($('#phone-country-code').val().length > 1) {
  //     $('p#pn').hide();
  //     const form = $(this).parents('form');
  //     if (nfcModalOpen) {
  //       return true;
  //     }
  //     const nfcEnabled = form.find('[name=nfc]:checked, [type=hidden][name=nfc]').eq(0).val();
  //     if (parseInt(nfcEnabled, 10)) {
  //       return true;
  //     }
  //     nfcModalOpen = true;
  //     event.preventDefault();
  //     event.stopPropagation();
  //     const modal = new Modal({
  //       body: '<p>You can still use your EmbassyCard <br/>with any merchants or friends <br/>NFC phones.</p>',
  //       fnContinue: () => {
  //         form.find('[type="submit"]').eq(0).click();
  //         setTimeout(() => {
  //           modal.close();
  //         });
  //       },
  //       fnOnClose: () => {
  //         nfcModalOpen = false;
  //       },
  //     });
  //     return true;
  //   } else {
  //     $('p#pn').text($('#phone-country-code').data('error-msg')).show();
  //     return false;
  //   }
  // });

  // STEP 3.1
  $('input[name=cardType]').on('change', function (event) {
    $('.card-descriptions').removeClass('d-block').addClass('d-none');
    if($(this).val() == 'EMBASSYCARD_LITE') {
      $('#card-desc-lite').removeClass('d-none').addClass('d-block');
    }
    if($(this).val() == 'EMBASSYCARD_GREEN') {
      $('#card-desc-green').removeClass('d-none').addClass('d-block');
    }
    if($(this).val() == 'EMBASSYCARD_GOLD') {
      $('#card-desc-gold').removeClass('d-none').addClass('d-block');
    }
  });

  // STEP 3.2
  $(document.body).on('click', 'input[data-message]', function (event) {
    event.preventDefault();
    const message = $(this).data('message');
    if (message) {
      const modal = new Modal({
        body: `<p>${message}</p>`,
        fnContinue: () => {
          modal.close();
        },
      });
    }
  });

  // STEP 3.2
  let deliverModalOpened = false;
  $('input[name=deliveryType]').on('change', function () {
    if($(this).val() === 'bank') {
      $('.delivery-bank-lists').removeClass('d-none');
    } else {
      $('.delivery-bank-lists').addClass('d-none');
    }

    if($(this).val() === 'merchant') {
      $('.delivery-merchants-lists').removeClass('d-none');
    } else {
      $('.delivery-merchants-lists').addClass('d-none');
    }
  });

  $('input[name=deliveryType]').on('click', function () {

    var formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: $(this).data('delivery-currency-code'),
    });

    var intformatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: $(this).data('international-delivery-currency-code'),
    });

      if($(this).val() === 'international_postage') {
      new Modal({
        body: '<p>A secure International Postage delivery service is available at your convenience with a postage cost of '+formatter.format(($(this).data('delivery-pennies')/100))+'</p>',
        fnContinue: () => {
          $(this).parents('form').submit();
        },
        backButtonText: 'Edit',
        continueButtonText: 'Continue'
      });
    }

    if($(this).val() === 'courier') {
      new Modal({
        body: '<p>A secure Courier Service is available at your convenience with a service charge of '+formatter.format(($(this).data('delivery-pennies')/100))+'</p><p>For delivery outside of Nigeria a secure International Postage delivery service is available at your convenience with a postage cost of '+intformatter.format(($(this).data('international-delivery-pennies')/100))+'</p>',
        fnContinue: () => {
          $(this).parents('form').submit();
        },
        backButtonText: 'Edit',
        continueButtonText: 'Continue'
      });
    }

  });

    $('#delivery-form').submit(function () {
    const option = $(this).find('[name=deliveryType]:checked');
    if (option.length) {
      const val = option.val();
      const form = $(this);
      // if (val === 'courier' && !deliverModalOpened) {
      //   deliverModalOpened = true;
      //   new Modal({
      //     body: '<p>A secure Courier Service is available<br/>\n'
      //         + 'at your convenience with a service<br/>\n'
      //         + 'charge of N500.00</p>',
      //     fnContinue: () => {
      //       form.submit();
      //     },
      //     fnOnClose: () => {
      //       deliverModalOpened = false;
      //     },
      //   });
      //   return false;
      // }
      return true;
    }
    return true;
  });

  // STEP 3.3.1
  $('#different_delivery_address').submit(function () {
    const val = $(this).find('[name=differentDelivery]:checked').val();
    const formID = `deliveryForm${val}`;

    const el = $(`#${formID}`);
    if (el.length) {
      $('.deliveryForm').hide();
      el.show();
    }
    return false;
  });

  $('#different_delivery_address input').on('change', function () {
    $(this).parents('form').submit();
  });

  // STEP 3.3.1
  let addressModalOpened = false;
  $('.deliveryForm').on('submit', function () {
    if (!window.checkFormValidity($(this))) {
      return false;
    }
    if (!addressModalOpened) {
      addressModalOpened = true;
      const fields = $(this).serializeArray();
      const addressFields = [
        'delivery_line1',
        'delivery_line2',
        'delivery_line3',
        'delivery_town',
        'delivery_postcode',
        'delivery_state',
        'delivery_country',
      ];
      let address = '';
      const deliveryCountryCode = getFormFieldByName(fields, 'delivery_country').value;
      addressFields.forEach((el, index) => {
        const field = getFormFieldByName(fields, el);
        if (field.value) {
          console.log(field.value);
          if (field.name.indexOf('country') > -1 && countries[field.value]) {
            field.value = countries[field.value];
          }
          if(field.name == 'delivery_postcode' && field.value.length > 0) {
            //address += ', ';
          }
          if(field.name == 'delivery_state') {
            if(deliveryCountryCode == 'NG') {
              if(field.value.indexOf('(provide if you have one)') < 1) {
                address += field.value + ' State';
              }
            }
          } else {
            if(field.value != ' ') {
              address += field.value;
            }
          }
          address += '<br />';
        }
      });
      const form = $(this);
      if(deliveryCountryCode != 'NG') {
        new Modal({
          body: `<h2 class="blue">Would you like International Postage instead?</h2><p>Courier, Bank or Merchant delivery methods cannot service non-Nigerian delivery addresses.</p><p>However, click 'Continue' to select International Postage for a delivery outside of Nigeria.</p>`,
          fnContinue: () => {
            form.find('input[name=action]').val('switch_to_tourist');
            form.submit();
          },
          fnOnClose: () => {
            addressModalOpened = false;
          },
          continueButtonText: 'Confirm',
        });
      } else {
        new Modal({
          body: `<h2 class="blue">Do we have your delivery address right?</h2>
               <p> ${address} </p>`,
          fnContinue: () => {
            form.submit();
          },
          fnOnClose: () => {
            addressModalOpened = false;
          },
          continueButtonText: 'Continue',
        });
      }
      return false;
    }
    return true;
  });

  // STEP 3.4
  $('[data-tin]').on('focus change focusout input paste', function () {
    const tinDig = $(this).data('tin');

    setTimeout(() => {
      $(`[data-tin=${tinDig}]`).not(this).val($(this).val());
    }, 100);
  });

  // STEP 3.4
  if($('input[name=bankAcc]').length) {
    const checkedBankAcc = parseInt($('input[name=bankAcc]:checked').val());
    if(checkedBankAcc === 1) {
      $('.bank-acc-step-0').hide();
      $('.bank-acc-step-1').show();
      $('input[name=action]').val('personal_bank_details');
    } else {
      $('.bank-acc-step-1').hide();
      $('.bank-acc-step-0').show();
      $('input[name=action]').val('personal_bank_details_new');
    }

    $('input[name=bankAcc]').on('change', function () {
      const checkedBankAcc = parseInt($('input[name=bankAcc]:checked').val());
      if(checkedBankAcc === 1) {
        $('.bank-acc-step-0').hide();
        $('.bank-acc-step-1').show();
        $('input[name=action]').val('personal_bank_details');
      } else {
        $('.bank-acc-step-1').hide();
        $('.bank-acc-step-0').show();
        $('input[name=action]').val('personal_bank_details_new');
      }

    });

  }

  // STEP 3.4
  let bankAccModalOpened = false;
  $('#bankAcc1').on('submit', function () {
    if (!window.checkFormValidity($(this))) {
      return false;
    }

    const checkedBankAcc = parseInt($('input[name=bankAcc]:checked').val());

    if(checkedBankAcc === 0) {
      if (!bankAccModalOpened) {
        bankAccModalOpened = true;
        const form = $(this);
        new Modal({
          body: `<p>Thank you for choosing our partner bank to\n
                 open your current account. We have sent them\n
                 your details and they will be in touch shortly.</p>`,
          fnContinue: () => {
            form.submit();
          },
          fnOnClose: () => {
            bankAccModalOpened = false;
          },
        });
        return false;
      }
    }
    return true;
  });

  // STEP 3.6
  let businessModalOpened = false;
  $('.business-address').on('submit', function () {
    if (!window.checkFormValidity($(this))) {
      return false;
    }
    if (!businessModalOpened) {
      businessModalOpened = true;
      const fields = $(this).serializeArray();
      const addressFields = [
        'business_line1', '<br/>',
        'business_line2', '<br/>',
        'business_line3', '<br/>',
        'business_town', 'business_postcode', '<br/>',
        'business_country', 'business_state',
      ];
      let address = '';
      const deliveryCountryCode = getFormFieldByName(fields, 'business_country').value;
      addressFields.forEach((el, index) => {
        const field = getFormFieldByName(fields, el);
        if (field.value) {
          if (field.name.indexOf('country') > -1 && countries[field.value]) {
            field.value = countries[field.value];
          }
          if(field.name == 'business_postcode' && field.value.length > 0) {
            address += ', ';
          }
          if(field.name == 'business_state') {
            if(deliveryCountryCode == 'NG') {
              if(field.value.indexOf('(provide if you have one)') < 1) {
                address += ', ';
                address += field.value;
              }
            }
          } else {
            address += field.value;
          }
        }
      });
      const form = $(this);
      new Modal({
        body: `<h2 class="blue">Do we have your business address right?</h2>
               <p> ${address} </p>`,
        fnContinue: () => {
          form.submit();
        },
        fnOnClose: () => {
          businessModalOpened = false;
        },
        continueButtonText: 'Confirm',
      });
      return false;
    }
    return true;
  });

  $('input[name=busAccExists]').on('change', function () {
    const checkedBusBankAcc = parseInt($('input[name=busAccExists]:checked').val());
    if (checkedBusBankAcc === 1) {
      $('select[name=business_bank_name]').prop('required', false);
      $('input[name=business_accName]').prop('required', false);
      $('.acc-num-group').each(function(index) {
        $(this).prop('required', false);
      });
      $('.bus-bank-acc-step-1').hide();
    } else {
      $('.bus-bank-acc-step-1').show();
      $('select[name=business_bank_name]').prop('required', true);
      $('input[name=business_accName]').prop('required', true);
      $('.acc-num-group').each(function(index) {
        $(this).prop('required', true);
      });
    }
  });

  // STEP 4.1 - Resend link/sms after anonymous registration
  $('#resend_confirmation_link_registration').submit(function () {
  });

  // STEP 4.1.1 - Invite a friend popup
  $('.invite-a-friend').click(function(event) {
    event.preventDefault();
    event.stopPropagation();
    new Modal({
      body: '<h1 class="green-alt mb-4">Want to Invite a Friend?</h1><p class="mb-4">Thanks for opening a Customer account with EmbassyCard! How about you invite others to join you?</p><p class="mb-4">By recommending others to EmbassyCard, you give them the opportunity to experience contactless payment and better money management using digital cash.</p>',
      fnContinue: () => {
        window.location.href = '/';
      },
      backButtonState: 'disabled',
      continueButtonText: 'Go back to homepage'
    });
  });

  // STEP 4.2 - Complete registration
  $('#complete_registration').submit(function () {
  });

  // STEP 4.3 - Resend link/sms after registration
  $('#resend_link_registration').submit(function () {
  });

  // Print Confirmation Button
  $('.print-confirmation').click(function(event) {
    window.print();
  })
}

